import store from "@redux/store";
import { MUTUAL_FUNDS_MANDATE_TRANSACTIONS_CLEAR_ALL_FILTERS, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_ERROR, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_HIDE_ERROR, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_RESET_ALL_FILTERS_AND_SEARCH, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_FILTERS, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_INITIAL_DATA, } from "../interface/IMutualFundsMandateTransactions";
var MutualFundMandateTransactions = /** @class */ (function () {
    function MutualFundMandateTransactions() {
        this.dispatch = store.dispatch;
    }
    MutualFundMandateTransactions.prototype.updateAppliedFilters = function (appliedFilters) {
        this.dispatch({
            type: MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_FILTERS,
            payload: { appliedFilters: appliedFilters },
        });
    };
    MutualFundMandateTransactions.prototype.clearAllFilters = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_MANDATE_TRANSACTIONS_CLEAR_ALL_FILTERS,
        });
    };
    MutualFundMandateTransactions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_MANDATE_TRANSACTIONS_ERROR,
            payload: { errorData: payload },
        });
    };
    MutualFundMandateTransactions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_MANDATE_TRANSACTIONS_HIDE_ERROR,
        });
    };
    MutualFundMandateTransactions.prototype.updateInitialData = function (initialDataFromAPI) {
        this.dispatch({
            type: MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_INITIAL_DATA,
            payload: { initialDataFromAPI: initialDataFromAPI },
        });
    };
    MutualFundMandateTransactions.prototype.resetMandateFiltersAndSearch = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_MANDATE_TRANSACTIONS_RESET_ALL_FILTERS_AND_SEARCH,
        });
    };
    return MutualFundMandateTransactions;
}());
export default MutualFundMandateTransactions;
